export default function (
  v,
  {
    string=false,
    number=false,
    object=false,
    date=false,
    array=false,
    nil=false,
    undef=false
  }
) {
  switch (Object.prototype.toString.call(v)) {
    case '[object String]':
      return string ? true : false;
    case '[object Number]':
      return number ? true : false;
    case '[object Object]':
      return object ? true : false;
    case '[object Date]':
      return object ? true : false;
    case '[object Array]':
      return array ? true : false;
    case '[object Null]':
      return nil ? true : false;
    case '[object Undefined]':
      return undef ? true : false
    default:
      return false
  }
}
